const navBar = {
  title: 'Como antecipar',
  aCompany: 'Uma empresa',
  steps: {
    first: {
      title: 'Primeiro passo',
      description:
        'Faça seu login no portal para conferir todos os títulos que tem a receber dos seus compradores.',
    },
    second: {
      title: 'Segundo passo',
      description:
        'Complete o cadastro da sua empresa no portal para poder solicitar antecipações sempre que quiser.',
    },
    third: {
      title: 'Terceiro passo',
      description:
        'Solicite antecipações de títulos diretamente com seus compradores informando a sua taxa de desconto.',
    },
  },
};

export default navBar;
